// The lost-access banner (contracts.md registry row "LostAccessBanner state"; ADR-0016; D49).
//
// Derived from `connections.status IN ('needs_action','revoked')`, account-scoped, surfaced to
// owner/admin only. Slice-2 triggers are an on-use failure and a webhook revoke; the proactive
// expiry watch is Slice 8 (D49). A read-model shape only; apps/api derives it, apps/web renders it.
import { z } from "zod";
import { ConnectionId } from "../ids.js";
import { NonEmptyString } from "./common.js";
import { ConnectionPlatform } from "./enums.js";
export const LostAccessBanner = z.object({
    connectionId: ConnectionId,
    platform: ConnectionPlatform,
    status: z.enum(["needs_action", "revoked"]),
    /** Plain-language name of what the founder must reconnect (e.g. "your GitHub connection"). */
    whatToReconnect: NonEmptyString,
    /** True when a shift or fix is paused waiting on this reconnection. */
    pausedWork: z.boolean(),
});
/** The full banner set for an account. */
export const BannerState = z.object({
    banners: z.array(LostAccessBanner),
});
//# sourceMappingURL=connection-banner.js.map